import React from "react";
import { Check, X } from "lucide-react";
import { Tile } from "./primitives";

export default function SubmissionsPanel({ subs, onChangeStatus }) {
  const pending = subs?.counts?.pending ?? 0;
  const items = subs?.submissions || [];
  return (
    <Tile title={`Author submissions (${pending} pending)`} testid="tile-submissions">
      {items.length === 0 ? (
        <div className="text-xs text-[#5C6B62]">
          No author submissions yet. Share /authors/submit.
        </div>
      ) : (
        <div className="space-y-2 max-h-72 overflow-y-auto">
          {items.map((s) => (
            <div
              key={s.submission_id}
              data-testid={`sub-${s.submission_id}`}
              className="text-xs border-b border-[#F0EFEA] pb-2 last:border-0"
            >
              <div className="flex items-center justify-between gap-2">
                <div className="font-medium text-[#1C2B23] truncate">{s.title}</div>
                <span
                  className={`text-[10px] px-2 py-0.5 rounded-full ${
                    s.status === "approved" || s.status === "published"
                      ? "bg-[#E8F0EB] text-[#2B5339]"
                      : s.status === "rejected"
                        ? "bg-[#FDF2ED] text-[#C26747]"
                        : "bg-[#F0EFEA] text-[#5C6B62]"
                  }`}
                >
                  {s.status}
                </span>
              </div>
              <div className="text-[#5C6B62] mt-0.5">
                {s.author_name} · {s.category} · ${s.price_usd}
              </div>
              <div className="text-[#5C6B62] mt-1 line-clamp-2">{s.blurb}</div>
              {s.status === "pending" && (
                <div className="flex gap-2 mt-2">
                  <button
                    data-testid={`approve-${s.submission_id}`}
                    onClick={() => onChangeStatus(s, "approved")}
                    className="inline-flex items-center gap-1 bg-[#2B5339] text-white text-[10px] px-2 py-1 rounded-full hover:bg-[#1C2B23]"
                  >
                    <Check size={10} /> Approve
                  </button>
                  <button
                    data-testid={`reject-${s.submission_id}`}
                    onClick={() => onChangeStatus(s, "rejected")}
                    className="inline-flex items-center gap-1 bg-[#F0EFEA] text-[#5C6B62] text-[10px] px-2 py-1 rounded-full hover:bg-[#FDF2ED] hover:text-[#C26747]"
                  >
                    <X size={10} /> Reject
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </Tile>
  );
}
